import {IPaylodAction, ITablesDispatcher} from '../../interfaces/dispatchers'
import DataActions from '../../enums/ActionTypes/DataActions'
import {IStore} from '../../interfaces/reducers'
import {ITableProps} from '../../interfaces/models'

export class TablesDispatcher implements ITablesDispatcher {
  constructor() {
    this.removeTabs = this.removeTabs.bind(this)
    this.setTablesVisibility = this.setTablesVisibility.bind(this)
    this.setTableInfoSelections = this.setTableInfoSelections.bind(this)
    this.setTableInfoExpanded = this.setTableInfoExpanded.bind(this)
    this.removeSelectedFeature = this.removeSelectedFeature.bind(this)
  }

  public removeSelectedFeature() {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      dispatch({
        type: DataActions.REMOVE__SINGLE_VIEW_SELECTED_FEATURE,
        payload: {}
      })
    }
  }

  public removeTabs(idsToRemote: string[], preserveIds?: string[]) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      const tabInfos = getStore().data.featureTables
      let tabsLeft: {[id: string]: Partial<ITableProps>} = {}
      if (preserveIds) {
        preserveIds.forEach(id => {
          if (tabInfos[id]) {
            tabsLeft[id] = tabInfos[id]
          }
        })
      } else {
        idsToRemote.forEach(id => {
          if (tabInfos[id]) {
            delete tabInfos[id]
          }
        })
        tabsLeft = tabInfos
      }
      dispatch({
        type: DataActions.SET_TABLES_EMPTY,
        payload: tabsLeft
      })
    }
  }

  public setTablesVisibility(tableIds: {[key: string]: string}) {
    return (dispatch: (data: IPaylodAction) => void) => {
      dispatch({
        type: DataActions.SET_TABLES_VISIBILITY,
        payload: tableIds
      })
    }
  }

  public setTableInfoSelections(tableId: string, selectedInput: {[key: string]: any}, add: boolean) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      const table = getStore().data.featureTables[tableId]
      if (table) {
        let selectedIds = table.selectedIds || {}
        selectedIds = {...selectedIds}
        if (add) {
          for (const key in selectedInput) {
            selectedIds[key] = selectedInput[key]
          }
        } else {
          for (const key in selectedInput) {
            delete selectedIds[key]
          }
        }
        dispatch({
          type: DataActions.UPDATE_SELECTIONS,
          payload: {tableId, selectedIds}
        })
      } else {
        console.warn(`Are you trying to set properties on non-existent table ${tableId} ?`)
      }
    }
  }

  public setTableInfoExpanded(tableId: string, expandedInput: {[key: string]: any}, add?: boolean) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      const table = getStore().data.featureTables[tableId]
      if (table) {
        let expanded = table.expanded || {}
        expanded = {...expanded}
        if (add === undefined) {
          // Works like toggle
          expanded = {}
          for (const key in expandedInput) {
            if (!table.expanded || !(table.expanded as any)[key]) {
              ;(expanded as any)[key] = expandedInput[key]
            }
          }
        } else {
          if (add) {
            for (const key in expandedInput) {
              ;(expanded as any)[key] = expandedInput[key]
            }
          } else {
            for (const key in expandedInput) {
              delete (expanded as any)[key]
            }
          }
        }
        dispatch({
          type: DataActions.UPDATE_EXPANDED,
          payload: {tableId, expanded}
        })
      } else {
        console.warn(`Are you trying to set properties on non-existent table ${tableId} ?`)
      }
    }
  }
}
